import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  modulesOptions: {
    data: {
      options: [],
    },
  },
  operationsOptions: {
    data: {
      options: [],
    },
  },
  moduleList: {
    list: {
      data: [],
      total: 0,
    },
  },
  roleGroupList: {
    list: {
      data: [],
      total: 0,
    },
  },
  roleGroupData: {
    data: null,
  },
  allRoleGroupList: {
    list: {
      data: [],
      total: 0,
    },
  },
  allModulesList: {
    list: {
      data: [],
      total: 0,
    },
  },
  roleList: {
    list: {
      data: [],
      total: 0,
    },
  },
  mastersList: {},
  mastersDataOptions: {
    data: {
      options: [],
    },
  },
  mastersDataList: {},
  usersList: {
    list: {
      data: [],
      total: 0,
    },
  },
  userCountryLocations: {
    data: [],
  },
  stateList: {
    list: {
      data: [],
      total: 0,
    },
  },
  cityList: {
    list: {
      data: [],
      total: 0,
    },
  },
  stockLocationList: {
    list: {
      data: [],
      total: 0,
    },
  },
  zoneList: {
    list: {
      data: [],
      total: 0,
    },
  },
  taxList: {
    list: {
      data: [],
      total: 0,
    },
  },
  deliveryChargeList: {
    list: {
      data: [],
      total: 0,
    },
  },
  reportConfigsList: {
    list: {
      data: [],
      total: 0,
    },
  },
  enrollmentTypeList: {
    list: [],
  },
  memberShipRoleList: {
    list: {
      data: [],
      total: 0,
    },
  },
  departmentList: {
    list: {
      data: [],
      total: 0,
    },
  },
  departmentOptions: {
    data: {
      options: [],
    },
  },
  locationsOptions: {
    data: {
      options: [],
    },
  },
  currencyList: {
    list: {
      data: [],
      total: 0,
    },
  },
  currencyConversionList: {
    list: {
      data: [],
      total: 0,
    },
  },
}

export default {
  state,
  actions,
  mutations,
  getters,
}
